import api from './../index'
import { IChatMessageModel } from 'models/chatMessage.model'

const createMessage = (courseId: number, { userId = 0, message, read = false, files }: IChatMessageModel) => {
  const data = new FormData()
  if (userId) data.append('user_id', String(userId))
  data.append('conversation[messages_attributes][][content]', message)
  data.append('conversation[messages_attributes][][read]', String(read))
  Object.values(files).map((file: any) => {
    data.append('conversation[messages_attributes][][attachments_attributes][][file]', file)
  })
  return api.post(`/courses/${courseId}/conversations`, data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export default createMessage
